import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Logout } from "../../utils/consts";

import Dropdown, {
  DropdownItemGroup,
  DropdownItem
} from "@atlaskit/dropdown-menu";
import Avatar from "@atlaskit/avatar";
// Skelton

import "./profileBtnMenu.css";
import { UserContext } from "../../Context";
export default class ProfileBtnMenu extends Component {
  logout = () => {
    // Promise.all(this.props.unsubscribers).then(() => Logout());
    Logout().then(() => window.location.reload());
  };

  render() {
    return (
      <UserContext.Consumer>
        {userContext => (
          <Dropdown
            trigger={
              <span tabIndex="0">
                {
                  <Avatar
                    appearance="circle"
                    name={userContext.email}
                    size="medium"
                    src={
                      userContext.my && userContext.my.photoURL
                        ? userContext.my.photoURL
                        : null
                    }
                  />
                }
              </span>
            }
            position="bottom right"
          >
            <DropdownItemGroup>
              {userContext.custom &&
                !!userContext.custom.admin && (
                  <Link className="profile-btn-menu__link" to="/admin">
                    <DropdownItem className="profile-btn-menu__item">
                      Admin
                    </DropdownItem>
                  </Link>
                )}
              <Link className="profile-btn-menu__link" to="/profile">
                <DropdownItem className="profile-btn-menu__item">
                  Profile
                </DropdownItem>
              </Link>
              <Link className="profile-btn-menu__link" to="/my/favs">
                <DropdownItem className="profile-btn-menu__item">
                  Favs
                </DropdownItem>
              </Link>
              <Link className="profile-btn-menu__link" to="/my/applications">
                <DropdownItem className="profile-btn-menu__item">
                  Applications
                </DropdownItem>
              </Link>
              <DropdownItem onClick={this.logout} target="_new">
                Logout
              </DropdownItem>
            </DropdownItemGroup>
          </Dropdown>
        )}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profileBtnMenu/ProfileBtnMenu.js